import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import type {
    SlackMessageAutomation as SlackMessageAutomationFragment,
    ClosedLeadSlackMessage as ClosedLeadSlackMessageFragment,
    ConditionInput,
} from 'nutshell-graphql-types';

import {FormSlackComponent} from './form-slack-component';
import type {SlackAutomationInput} from './form-slack-component';

import styles from '../sales-process-form.module.css';

type Props = {
    formSubmitBtnRef: (arg1?: HTMLInputElement | null | undefined) => void;
    parentId: string;
    stagesetId: string;
    slackMessageAutomation:
        | ClosedLeadSlackMessageFragment
        | null
        | undefined
        | SlackMessageAutomationFragment
        | null
        | undefined;
    isFetchingLatestVersion: boolean;
    deleteSlackAutomation: (arg1: string) => Promise<any>;
    onSubmit: (arg1: string, arg2: Array<ConditionInput>, arg3: string) => Promise<any>;
};

export class FormSlackGraphQLComponent extends React.PureComponent<Props> {
    render() {
        if (!this.props.slackMessageAutomation && this.props.isFetchingLatestVersion) {
            return (
                <div className={styles['loading-container']}>
                    <LoadingIcon />
                </div>
            );
        }

        return (
            <FormSlackComponent
                stagesetId={this.props.stagesetId}
                isFetchingLatestVersion={this.props.isFetchingLatestVersion}
                parentId={this.props.parentId}
                slackMessageAutomation={this.props.slackMessageAutomation}
                formSubmitBtnRef={this.props.formSubmitBtnRef}
                onSubmit={this.handleSubmit}
                onDelete={this.deleteForm}
            />
        );
    }

    handleSubmit = (formData: SlackAutomationInput) => {
        const conditions: Array<ConditionInput> = [];
        if (formData.leadValueCondition) {
            conditions.push({
                config: {
                    filter: {
                        fieldName: 'value',
                        fieldType: 'CURRENCY',
                        currencyConfig: {
                            currencyValue: formData.leadValue,
                            currencyComparator: formData.leadValueComparator,
                            currencyCode: formData.leadValueCurrencyCode,
                        },
                    },
                },
            });
        }

        return this.props.onSubmit(formData.channelId, conditions, formData.outcomeType);
    };

    deleteForm = (slackAutomationId: string) => {
        return this.props.deleteSlackAutomation(slackAutomationId);
    };
}
